import { type Shop, ThemeFont, ThemeMode } from '@prisma/client'
import type { Dispatch, SetStateAction } from 'react'
import { createContext } from 'react'

export type ShopContextData = Pick<
  Shop,
  'themeColor' | 'themeMode' | 'themeFont'
>

export type ShopContextType = [
  ShopContextData,
  Dispatch<SetStateAction<ShopContextData>>,
]

export const ShopContext = createContext<ShopContextType>([
  { themeColor: null, themeMode: ThemeMode.overall, themeFont: ThemeFont.sans },
  () => {
    // noop
  },
])
